import { UserInterface } from './user.model';

export interface ErgoTeamMemberInterface {
  memberUser?: UserInterface;
  ergoRoleId?: number;
  ergoRoleLabel?: string;
}

export class ErgoTeamMember implements ErgoTeamMemberInterface {
  public memberUser?: UserInterface;
  public ergoRoleId?: number;
  public ergoRoleLabel?: string;

  constructor({
    memberUser = undefined,
    ergoRoleId = undefined,
    ergoRoleLabel = undefined,
  }: ErgoTeamMemberInterface) {
    this.memberUser = memberUser;
    this.ergoRoleId = ergoRoleId;
    this.ergoRoleLabel = ergoRoleLabel;
  }
}
